import { env } from '@/env';
import { Retailer } from '@/types';

const backgroundStyles = (retailerId: string) => ({
  background: `url(${env.VITE_STATIC_URL}/retailer/images/${retailerId}-banner.png)`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
});

interface RetailerInfoProps {
  retailer: Retailer;
}

const RetailerInfo = (props: RetailerInfoProps) => {
  const { retailer } = props;

  return (
    <div className="rounded-10-0 flex flex-col md:flex-row overflow-hidden min-h-[20rem]">
      <div
        className="w-full md:w-1/2 justify-between bg-info h-[90px] md:h-auto"
        style={backgroundStyles(retailer.id)}
      ></div>
      <div
        className="w-full md:w-1/2  text-primary-white flex items-center p-2-0"
        style={{ backgroundColor: retailer.colour || 'bg-primary-blue' }}
      >
        <div>
          <h1 className="font-bold text-2-4 mb-2-0">{retailer.name}</h1>
          <p className="text-1-4 font-rg leading-1-94">
            {retailer.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default RetailerInfo;
